var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","name":"overlay-fade"}},[(_vm.active)?_c('div',{staticClass:"overlay",attrs:{"id":"overlay"}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }